module.exports.default = {
    "ORDER": "Order",
    "SCHEDULE.YOU_ARE_ALL_SET": "You're all set",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Your appointment is scheduled for",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Hi #. Please schedule your appointment:",
    "SCHEDULE.SCHEDULE_NOW": "Schedule",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Order Updates",
    "SCHEDULE.EMAIL_UPDATES": "E-Mail updates",
    "SCHEDULE.SMS_UPDATES": "SMS updates",
    "SCHEDULE.DISABLE_UPDATES": "I don’t want to receive updates",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "I would like to receive status updates on my delivery in the following channels:",
    "OOPS": "Oops!",
    "SOMETHING_WENT_WRONG": "Something went wrong.",
    "REFRESH": "Refresh",
    "PAGE_NOT_FOUND": "Page not found",
    "COULD_NOT_FIND_PAGE": "We couldn't find the page you were looking for.",
    "TRACKING.MESSAGE_DRIVER_FAILED": "Cannot send an empty message",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Please enter your message to the driver",
    "TRACKING.SEND": "Send",
    "TRACKING.ARRIVING_AT": "Arriving at",
    "TRACKING.ETA": "ETA",
    "TRACKING.MIN": "min",
    "TRACKING.MAP": "Map",
    "TRACKING.SATELLITE": "Satellite",
    "TRACKING.TERRAIN": "Terrain",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Hey, I've arrived !",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "your driver, has arrived at",
    "COMPLETED": "Completed",
    "RATING.SKIP": "Skip",
    "RATING.WHAT_WENT_WELL": "What went well?",
    "RATING.WHAT_WENT_WRONG": "What went wrong?",
    "RATING.THANK_YOU": "Thank you",
    "RATING.FOR_USING_OUR_SERVICE": "for using our service!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "How was your delivery experience?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Please help us improve by rating your experience",
    "SCHEDULE.RATE_US": "Rate us",
    "TERM_OF_USE": "Terms of use",
    "PRIVACY_POLICY": "Privacy policy",
    "SHARING_MY_LOCATION": "Sharing my location",
    "SHARING_LOADING": "Sharing loading...",
    "REQUIRED_FIELD_MESSAGE": "This field is required",
    "CONTACT_NAME": "Contact Name",
    "PHONE_NUMBER": "Phone Number",
    "EMAIL_ADDRESS": "Email address",
    "SEND": "Send",
    "FORWARD.THIS_ORDER": "Forward this order",
    "FORWARD.TO_CONTACT": "Forward to contact",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Are you sure you want to forward this order?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "has forwarded a delivery to you",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Are you sure you want to reject this order?",
    "ACCEPT": "Accept",
    "REJECT": "Reject",
    "PICKUP.SET_PICKUP_TIME": "I'm on my way",
    "PICKUP.IVE_ARRIVED": "I've arrived",
    "PICKUP.PICKUP_ETA_SET_FAILED": "Oops, something went wrong.\n",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "Please try again.",
    "PICKUP.MIN": "min",
    "PICKUP.SHOW_THIS_NUMBER": "Show this number to the clerk to receive your order",
    "PICKUP.IM_OUTSIDE": "I'm here",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "Let us know when you are here.",
    "PICKUP.I_WILL_ARRIVE_AT": "I will arrive at",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "Pickup Time successfully set",
    "PICKUP.IN": "In",
    "PICKUP.TO": "To",
    "PICKUP.COLLECT": "Order Collected",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "Select Method of Transport",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "Confirm method of transport",
    "PICKUP.CANCEL": "Cancel",
    "PICKUP.CONFIRM_TIME": "Confirm pickup arrival time",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "The driver is currently one stop away from you",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "stops away from you",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "The driver is currently",
    "PICKUP.OK": "OK",
    "PICKUP.NEXT": "Next",
    "PICKUP.SKIP": "Skip",
    "CAR_ARRIVED.TITLE": "Last step! Let us know how to find you:",
    "CAR_ARRIVED.PARKING_SPOT": "Parking Area / Spot Number",
    "CAR_ARRIVED.LICENSE_PLATE": "License Plate",
    "CAR_ARRIVED.VEHICLE_MODEL": "Vehicle Model & Make",
    "CAR_ARRIVED.VEHICLE_COLOR": "Vehicle Color",
    "CAR_ARRIVED.REMEMBER": "Remember my vehicle details",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "(Example: C - 49)",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "(Example: 195-QUD)",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "(Example: Ford Bronco)",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "(Example: Blue)",
    "REDIRECT_PICKUP.TO": "To",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "Change the pickup location?",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "Pickup location successfully changed",
    "REDIRECT_PICKUP.FAILED_TITLE": "Could not change pickup location",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "Something went wrong",
    "REDIRECT_PICKUP.OK": "OK",
    "REDIRECT_PICKUP.KM": "km",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "Select pickup location",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "Set as pickup location",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "Pickup Options",
    "SOON": "Soon",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "Want to call your delivery driver?",
    "GLOBAL.CALL": "Call",
    "GLOBAL.CANCEL": "Cancel",
    "﻿PICKUP.SET_PICKUP_TIME": "I'm on my way",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "Your order is waiting for you right outside your door!",
    "SCHEDULED.THANKS_FOR_USING": "Thanks for using {{merchant_name}}",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "Your shipment {{external_id}} is in transit",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Your order is scheduled for",
    "Submit": "Submit",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "To rate, select the stars first",
    "PICKUP.SHOW_ID": "Show ID",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "Estimated Time of Arrival",
    "OPEN_MENU": "Open Menu",
    "CLOSE_MENU": "Close Menu",
    "MAP_AUTO_CENTER": "Auto center map",
    "MAP_SETTINGS": "Map settings",
    "ZOOM_OUT": "Zoom out",
    "ZOOM_IN": "Zoom in",
    "TRACKING.CALL_DRIVER": "Call Driver",
    "TRACKING.MESSAGE_DRIVER": "Message the driver",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "Confirm pickup arrival time",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "We don't want you to wait.\nLet us know when you're on your way or arriving:",
    "SCHEDULE.TIME_ZONE_TEXT": "Time Zone",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "We are working on it!",
    "TRACKING.THANKS_MESSAGE_TEXT": "We are collecting your items and a team member will be out to your car shortly",
    "TRACKING.THANKS_MESSAGE_TITLE": "Thanks for checking in",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "Please go to the collection point in store where your order is ready for collection",
    "CANCEL_ORDER": "Cancel Order",
    "CANCELLATION_VALIDATION_TITLE": "Are you sure you want to cancel this order?",
    "CANCELLATION_VALIDATION_BACK": "Back",
    "CANCELLATION_VALIDATION_YES": "Yes, please",
    "CANCEL_SUCCESS": "We’ve canceled your order",
    "CANCEL_PAST_ALLOWED": "Cancellation of order expired",
    "CANCEL_ERROR": "We were unable to cancel your order",
    "RATING.FREE_TEXT_COMMENT": "Tell us more",
    "RATING.ORDER_DELIVERED_GREEN": "We delivered your order with an eco-friendly vehicle",
    "CX_ORDER_STATUS.CONFIRMED": "Order confirmed. We’re on it.",
    "CX_ORDER_STATUS.RECEIVED": "Order received. We’ll be in touch shortly.",
    "CX_ORDER_STATUS.FINDING_DRIVER": "We’re finding a driver for your order.",
    "CX_ORDER_STATUS.DRIVER_FOUND": "We’ve found the driver for your order.",
    "CX_ORDER_STATUS.PICKING_UP": "We’re picking up your order right now.",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "We’re on our way to pick up your order.",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "We’re completing a previous delivery before your order.",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "Your order is on its way to you now!",
    "CX_ORDER_STATUS.ARRIVED": "Your order has arrived!",
    "TRACKING.DELIVERY_STATUS_TITLE": "Delivery Status",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "Show delivery status to customers",
    "CONFIRM": "Confirm",
    "FLOW_OPTIONS.TITLE": "How do you want to collect your order?",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "Delivered to your car in a designated spot",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "Curbside",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "Pickup in-store or at a set location",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "Click & collect",
    "RATING_STAR_ALT": "Select up to 5 stars to submit a rating",
    "RATING_STAR_ALT_ONE": "Select to submit",
    "RATING_STAR_ALT_TWO": "stars rating",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "The estimated time of arrival is",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "Map to track the order",
    "SCHEDULE.EXTERNAL_ID_INFO": "Order ID: {{externalId}}",
    "SCHEDULE.TASK_NOTE_LABEL": "Comment",
    "SCHEDULE.CANCEL_NOTE_INPUT": "Clear",
    "DELIVERY_WAS_CANCELLED": "Delivery was Cancelled",
    "QUESTIONNAIRE.SKIP": "Skip",
    "QUESTIONNAIRE.SKIP_VALIDATION_HEADER": "Are you sure you want to skip?",
    "QUESTIONNAIRE.SKIP_VALIDATION_MESSAGE": "Are you sure you want to skip this question and continue?",
    "QUESTIONNAIRE.BACK": "Back",
    "QUESTIONNAIRE.SUBMIT_FAILED": "We couldn’t submit your responses. Please try again.\n",
    "QUESTIONNAIRE.SUBMIT_SUCCESS": "Your responses have been submitted successfully.",
    "QUESTIONNAIRE.NA_VALUE": "N/A",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_TITLE": "Questionnaire submitted",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_MESSAGE": "Your responses have been submitted successfully. You may now close this window.",
    "QUESTIONNAIRE.PROGRESS_BAR_TITLE": "Progress",
    "QUESTIONNAIRE.NEXT": "Next",
    "QUESTIONNAIRE.INVALID_FORMAT": "The format is invalid. Please check your input and try again."
};
	